exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1AzHL .slick-dots li:not(.slick-active){margin-top:3px}._1AzHL .slick-dots li.slick-active{margin:0 6px;border:2px solid #ffc107;border-radius:10px}._1AzHL .slick-dots li button{width:10px;height:10px;border-radius:10px;background:#c4c4c4}._1AzHL .slick-dots li.slick-active button{width:13px;height:13px;border-radius:16px;border-width:3px;background-color:#ffc107;border:3px solid #fff}", ""]);

// exports
exports.locals = {
	"root": "_1AzHL"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/shared/components/Article/Leasing/LeasingFeedback/LeasingFeedback.css
// module id = 3239
// module chunks = 21